
import { WebStorageStateStore } from 'oidc-client-ts';

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const defaultRedirectUri = isLocalhost
  ? `${window.location.origin}/callback`
  : 'https://clairai.cloud/callback';

export const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY ?? '',
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID ?? '',
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI ?? defaultRedirectUri,
  response_type: process.env.REACT_APP_COGNITO_RESPONSE_TYPE ?? 'code',
  scope: process.env.REACT_APP_COGNITO_SCOPE ?? 'openid email profile',
  automaticSilentRenew: process.env.REACT_APP_COGNITO_SILENT_RENEW === 'true',
  loadUserInfo: process.env.REACT_APP_COGNITO_LOAD_USER_INFO === 'true',
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
};

export const isAuthEnabled = process.env.REACT_APP_AUTH_ENABLED !== 'false';

export const isLocalAuthBypassEnabled =
  !isAuthEnabled ||
  (process.env.REACT_APP_LOCAL_AUTH_BYPASS === 'true' && isLocalhost);
